module.exports = __webpack_public_path__ + "img/1.fc588c21.png";